
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/immoneuf",
      function () {
        return require("private-next-pages/immoneuf/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/immoneuf"])
      });
    }
  